// extracted by mini-css-extract-plugin
var _1 = "AddSeats__backdrop--M9eIA";
var _2 = "AddSeats__button--UOhjv SchoolGeneral__add--HUNaY SchoolGeneral__button--ZIm36";
var _3 = "AddSeats__buttonDisabled--aLkrb";
var _4 = "AddSeats__buttonRow--Nancb";
var _5 = "AddSeats__confirmationCheckbox--yApWp";
var _6 = "AddSeats__confirmationContainer--NP21Y";
var _7 = "AddSeats__editLimitButton--tw_hD SchoolGeneral__button--ZIm36";
var _8 = "AddSeats__input--DPh6V SchoolGeneral__input--THKc2";
var _9 = "AddSeats__inputError--WL_8h";
var _a = "AddSeats__instructions--TKybK";
var _b = "AddSeats__iplDisclaimer--yuCpY";
var _c = "AddSeats__label--IEPhq";
var _d = "AddSeats__labeledValue--NQQo0";
var _e = "AddSeats__link--pKBak";
var _f = "AddSeats__loading--aMl25";
var _10 = "AddSeats__loadingContainer--yulbg AddSeats__button--UOhjv SchoolGeneral__add--HUNaY SchoolGeneral__button--ZIm36";
var _11 = "AddSeats__modal--jpiwe OfficeModalsGeneral__main--zoMc5 OfficeModalsGeneral__mainBase--XCZpq OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _12 = "AddSeats__modalText--Ai6OE OfficeGeneral__textSizeB--Ye78Y CoreGeneral__textSizeB--joAuE";
var _13 = "AddSeats__numberInput--MYEU6";
var _14 = "AddSeats__textarea--Oiibw";
var _15 = "AddSeats__title--gvGha OfficeGeneral__textSizeA--ZYpjj CoreGeneral__textSizeA--JbJdW";
var _16 = "AddSeats__vertical--yo0dr";
export { _1 as "backdrop", _2 as "button", _3 as "buttonDisabled", _4 as "buttonRow", _5 as "confirmationCheckbox", _6 as "confirmationContainer", _7 as "editLimitButton", _8 as "input", _9 as "inputError", _a as "instructions", _b as "iplDisclaimer", _c as "label", _d as "labeledValue", _e as "link", _f as "loading", _10 as "loadingContainer", _11 as "modal", _12 as "modalText", _13 as "numberInput", _14 as "textarea", _15 as "title", _16 as "vertical" }
